import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { UserService } from '../services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class InternalUserGuard implements CanActivate {
  private internalUser = false; // This is for both admin and the read only user types

  constructor(private user: UserService) {
    user.isInternal.subscribe(internal => {
      this.internalUser = internal;
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.internalUser;
  }
}
